module.exports = __webpack_public_path__ + "img/cavp.557ebe93.svg";